import { PropsWithChildren } from 'react';
import styles from './TextContent.module.scss';

export function TextContent({ children }: PropsWithChildren) {
  return <div className={styles.wrapper}>{children}</div>;
}
